import React from 'react';
import dayjs from 'dayjs';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Provider } from './config/store';
import NavRoutes from './routes/NavRoutes';

// import reportWebVitals from './reportWebVitals';

// Google Tag Manager with Analytics, init on Prod only
import settings from './config/settings';
import { initAmplitude } from './utils/amplitudeUtils';

dayjs.extend(customParseFormat);

if (settings.GOOGLE_TAG_MANAGER_PROD) {
  const tagManagerArgs = { gtmId: settings.GOOGLE_TAG_MANAGER_PROD };
  TagManager.initialize(tagManagerArgs);
}

if (settings.AMPLITUDE_KEY) {
  initAmplitude();
}

if (settings.SENTRY) {
  Sentry.init({
    dsn: settings.SENTRY,
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider>
      <NavRoutes />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
